<template>
  <div class="sso-signout">
    <div class="signout-container">
      <h1>Uitloggen...</h1>
      <p>U wordt uitgelogd en alle sessiegegevens worden gewist.</p>
      <div class="loading-spinner"></div>
    </div>
  </div>
</template>

<script>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { formLogout} from '@/services';

export default {
  name: 'SSOSignOut',
  setup() {
    const router = useRouter();

    const clearAllStorage = () => {
      // Clear localStorage
      localStorage.clear();

      // Clear sessionStorage
      sessionStorage.clear();

      // Additional cleanup for specific items if needed
      // Remove specific items that might be set by the application
      const itemsToRemove = [
        'user',
        'token',
        'authToken',
        'refreshToken',
        'userSession',
        'loginState',
        'redirectedFromRegistration'
      ];

      itemsToRemove.forEach(item => {
        localStorage.removeItem(item);
        sessionStorage.removeItem(item);
      });

      console.log('All storage cleared successfully');
    };

    const redirectToLogin = () => {
      // Redirect to login page after a short delay
      formLogout()
        .then((r) => {
          router.push('/inloggen')
        })
        .catch((error) => {
          console.error('Logout error:', error);
          // Still redirect to login page even on error
          router.push('/inloggen')
        });
    };

    onMounted(() => {
      // Clear all storage immediately when component mounts
      clearAllStorage();

      // Redirect to login page
      redirectToLogin();
    });

    return {};
  }
};
</script>

<style scoped>
.sso-signout {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5;
  font-family: Arial, sans-serif;
}

.signout-container {
  text-align: center;
  padding: 2rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-width: 400px;
}

.signout-container h1 {
  color: #333;
  margin-bottom: 1rem;
  font-size: 1.5rem;
}

.signout-container p {
  color: #666;
  margin-bottom: 2rem;
  line-height: 1.5;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
